import { Component, OnChanges, Input } from '@angular/core';
import { WeekRow, WeekDay } from '../../../shared/week-row'
import { ProblemToken } from '../../../shared/problem-token'
import { GenService } from '../../../shared/gen-ser.service';
import { DataService } from '../../../shared/dataservice.service';
@Component({
  selector: 'bs-calendar',
  templateUrl: './bs-calendar.component.html',
  styleUrls: ['./bs-calendar.component.css']
})
export class BSCalendarComponent implements OnChanges {
  @Input() year:number;
  @Input() month:number;

  today:Date = new Date();

  isLoaded:boolean = false;

  weeks:Array<WeekRow> = []

  constructor( private dataService:DataService) {
   }

  ngOnChanges() {
    this.prepareCalendarData();
  }

  private prepareCalendarData(){
    this.isLoaded = false;
    let _weeks:Array<WeekRow> = []
    
    let _weekNums:Array<number> = GenService.getWeekNumbersForMonth(this.year,this.month);
    let _startDate:Date = null;
    let _endDate:Date = null;

     for(var i=0;i<_weekNums.length;i++){
          let wRow:WeekRow = new WeekRow(_weekNums[i]);
          let _dates:Array<Date> = GenService.getDatesForWeek(_weekNums[i],this.year);
          _dates.forEach((_dt:Date) => {
              wRow.addDay(_dt);
              if(_startDate == null) _startDate = _dt;
              if(_endDate == null || _endDate < _dt) _endDate = _dt;
          });
          _weeks.push(wRow);  
     }
    this.weeks = _weeks;
    this.dataService.loadProblemsinDateRange(_startDate,_endDate).subscribe((_probs:Array<ProblemToken>) => {
        if(_probs.length > 0){
            _probs.forEach((_problem:ProblemToken) => {
                let _viewingDateNum:number = _problem.getViewingDate(_startDate,_endDate);
                if(_viewingDateNum != null){
                  let _currProbTime = new Date(_viewingDateNum);
                  let _weekNum:number = GenService.getWeekNum(_currProbTime);
                  let _tmpIndex:number = _weeks.findIndex((_currWeek:WeekRow) => {
                    return _currWeek.weekNumber == _weekNum;
                  });
                  if(_tmpIndex >= 0){
                      _weeks[_tmpIndex].addProblem(_currProbTime,_problem);
                  }
                }
            });
        }
    });
    this.isLoaded = true;
  }

}
